import { NgModule } from '@angular/core';
import { RouterModule, Routes, } from '@angular/router';

//Angular analytics
import { Angulartics2Module, } from 'angulartics2';

//Component
// import { PointofsaleComponent } from 'src/app/components/order/pointofsale/pointofsale.component';
import { FullePointofsaleComponent } from 'src/app/components/order/fulle-pointofsale/fulle-pointofsale.component';
// import { ProductComponent } from 'src/app/components/order/product/product.component';
import { FulleProductComponent } from 'src/app/components/order/fulle-product/fulle-product.component';
import { FulleEndorderComponent } from '../components/order/fulle-endorder/fulle-endorder.component';
// import { EndorderComponent } from 'src/app/components/order/endorder/endorder.component';
import { AuthComponent } from '../components/auth/auth.component';
import { MainComponent } from '../components/client/main.component';
import { RedirectFbComponent } from '../components/auth/redirect-fb/redirect-fb.component';
import { ErrorUrlComponent } from '../components/redirect/error/error-url/error-url.component';
import { SuccessOrderComponent } from '../components/order/success-order/success-order.component';
import { DisabledOrderComponent } from '../components/redirect/error/disabled-order/disabled-order.component';
import { InvoiceRechargeComponent } from '../components/includes/ext/invoice-recharge/invoice-recharge.component';
import { DashboardComponent } from '../components/client/dashboard/dashboard.component';
import { AccountComponent } from '../components/client/account/account.component';
import { AddressesComponent } from '../components/client/addresses/addresses.component';
import { CardsComponent } from '../components/client/cards/cards.component';
import { NotesComponent } from '../components/client/notes/notes.component';
import { OrdersComponent } from '../components/client/orders/orders.component';
import { RechargeComponent } from '../components/client/recharge/recharge.component';
import { MerchantOptionsComponent } from '../components/client/merchant-options/merchant-options.component';
import { RefillsComponent } from '../components/client/refills/refills.component';
import { FidelityComponent } from '../components/client/fidelity/fidelity.component';
import { CashlessOptionsComponent } from '../components/client/cashless-options/cashless-options.component';
import { WaitingNotesComponent } from '../components/order/waiting-notes/waitingnotes.component';

//Service
import { GuardProductService } from 'src/app/services/guards/guard-product.service';
import { GuardEndorderService } from '../services/guards/guard-endorder.service';
import { AuthGuardService as Authguard } from '../services/guards/auth-guard.service';
import { UserGuardService } from '../services/guards/user-guard.service';
import { AuthGuardMainService } from '../services/guards/auth-guard-main.service';
import { AuthGuardRedirectFb } from '../services/guards/redirect-fb-guard.service';
import { GuardSuccessOrderService } from '../services/guards/guard-success-order.service';
import { GuardCurrencyService } from '../services/guards/guard-currency.service';
import { FulleMerchantTermsComponent } from '../components/includes/fulle-merchant-terms/fulle-merchant-terms.component';
import { ClientAccountLogsComponent } from '../components/api-logs/client-account-logs/client-account-logs.component';
import { MetaTitleGuard } from '../services/guards/meta-title.guard';
import { TableReservationComponent } from '../components/order/table-reservation/table-reservation.component';
import { ReservationComponent } from '../components/client/booking/reservation/reservation.component';
import { MerchantComponent } from '../components/client/booking/merchant/merchant.component';
import { CreditsComponent } from '../components/client/credits/credits.component';
import { GuardUserDomainService } from '../services/guards/guard-user-domain.service';
import { GuardUserDomainSalemethodService } from '../services/guards/guard-user-domain-salemethod.service';
import { StockResolver } from "../resolvers/stock.resolver";
import { PricePeriodResolver } from "../resolvers/price-period.resolver";
import { HomeInterfaceComponent } from '../components/home-interface/home-interface.component';
import { CreateUrlTokenComponent } from '../components/url-token/create-url-token.component';
import { UpdateDeviceScreenComponent } from '../components/mc-connect-table/update-device-screen/update-device-screen.component';
import { PngGeneratorComponent } from '../components/mc-connect-table/png-generator/png-generator-component.component';
import { DeviceListComponent } from '../components/mc-connect-table/device-list/device-list.component';
import { ChangeDeviceAffectationComponent } from '../components/mc-connect-table/change-device-affectation/change-device-affectation.component';
import { FulleProductModeBorneComponent } from '../components/order/fulle-product-mode-borne/fulle-product-mode-borne.component';
import { FulleSelectionSMComponent } from '../components/order/fulle-selection-SM/fulle-selection-SM.component';
import { FulleProductV2Component } from '../components/order/fulle-product-v2/fulle-product-v2.component';

const routes: Routes = [

  // Default
  { path: '', redirectTo: '/auth/home', pathMatch: 'full' },

  {
    path: 'seeMyConnectedDevices',
    component: DeviceListComponent,
    // canActivate: [GuardUserDomainService, UserGuardService, GuardCurrencyService, MetaTitleGuard],
    resolve: {
    },
  },

  {
    path: 'deviceAssignation',
    component: ChangeDeviceAffectationComponent,
    // canActivate: [GuardUserDomainService, UserGuardService, GuardCurrencyService, MetaTitleGuard],
    resolve: {
    },
  },


  {
    path: 'changeImageMCConnectTable',
    component: UpdateDeviceScreenComponent,
    // canActivate: [GuardUserDomainService, UserGuardService, GuardCurrencyService, MetaTitleGuard],
    resolve: {
    },
  },

  {
    path: 'createpng',
    component: PngGeneratorComponent,
    // canActivate: [GuardUserDomainService, UserGuardService, GuardCurrencyService, MetaTitleGuard],
    resolve: {
    },
  },

  {
    path: 'note/:merchantName/:webshopId/:locValue',
    component: WaitingNotesComponent,
    canActivate: [GuardUserDomainService, UserGuardService, GuardCurrencyService, MetaTitleGuard],
    resolve: {
    },
  },

  // Méthode Anthony, pour coler exactement aux autres routes
  // Nom du marchand, code point de vente, mode de vente, information de note (ID + VALUE)
  {
    path: 'qrcode/:merchantName/:webshopId/sm/:smId/loc/:locId/:locValue',
    component: HomeInterfaceComponent,
    canActivate: [GuardCurrencyService, MetaTitleGuard]
  },

  {
    path: 'create_url_token',
    component: CreateUrlTokenComponent,
    resolve: {
    },
  },

  // Ecran de choix des points de vente
  {
    path: 'p/:merchantName/:merchantId',
    component: FullePointofsaleComponent,
    canActivate: [GuardUserDomainService, GuardProductService, UserGuardService, GuardCurrencyService, MetaTitleGuard]
  },

  // Ecran produits / modes de vente
  // {
  //   path: 's',
  //   component: FulleProductComponent,
  //   canActivate: [GuardUserDomainSalemethodService, GuardProductService, UserGuardService, GuardCurrencyService, MetaTitleGuard],
  //   resolve: {
  //     stocks: StockResolver,
  //     pricePeriods: PricePeriodResolver
  //   },
  // },

  ////// route vers le choix entre les differentes sale_method //////
  {
    path: 's/:merchantName/:webshopId',
    component: FulleSelectionSMComponent,

    canActivate: [GuardUserDomainSalemethodService, GuardProductService, UserGuardService, GuardCurrencyService, MetaTitleGuard],
    resolve: {
      stocks: StockResolver,
      pricePeriods: PricePeriodResolver
    },
  },
  //ancienne version
  // {
  //   path: 's2/:merchantName/:webshopId',
  //   component: FulleProductComponent,

  //   canActivate: [GuardUserDomainSalemethodService, GuardProductService, UserGuardService, GuardCurrencyService, MetaTitleGuard],
  //   resolve: {
  //     stocks: StockResolver,
  //     pricePeriods: PricePeriodResolver
  //   },
  // },
  ////// Ouvre une sale_method directement //////
  // ancienne version
  {
    path: 's/:merchantName/:webshopId/:smId',
    component: FulleProductComponent,
    canActivate: [GuardUserDomainSalemethodService, UserGuardService, GuardCurrencyService, MetaTitleGuard],
    resolve: {
      stocks: StockResolver,
      pricePeriods: PricePeriodResolver
    },
  },
  // nouvelle version
  {
    path: 's2/:merchantName/:webshopId/:smId',
    component: FulleProductV2Component,
    canActivate: [GuardUserDomainSalemethodService, UserGuardService, GuardCurrencyService, MetaTitleGuard],
    resolve: {
      stocks: StockResolver,
      pricePeriods: PricePeriodResolver
    },
  },
  ////// Ouvre la sale_method mode borne //////
  {
    path: 's/:merchantName/:webshopId/:smId/:inId/:value',
    component: FulleProductModeBorneComponent,
    canActivate: [GuardUserDomainSalemethodService, UserGuardService, GuardCurrencyService, MetaTitleGuard],
    resolve: {
      stocks: StockResolver,
      pricePeriods: PricePeriodResolver
    },
  },

  //TODO deprecated
  // {
  //   path: 'product',
  //   component: FulleProductComponent,
  //   canActivate: [GuardProductService, UserGuardService, GuardCurrencyService, MetaTitleGuard],
  //   resolve: {
  //     stocks: StockResolver,
  //     pricePeriods: PricePeriodResolver
  //   },
  // },

  // Table reservation
  {
    path: 'tr/:merchantName/:webshopId',
    component: TableReservationComponent,
    canActivate: [GuardProductService, UserGuardService, GuardCurrencyService, MetaTitleGuard]
  },

  {
    path: 'endorder',
    component: FulleEndorderComponent,
    canActivate: [GuardEndorderService, UserGuardService, GuardCurrencyService, MetaTitleGuard]
  },
  {
    path: 'endorder/:nepting/:payment',
    component: FulleEndorderComponent,
    canActivate: [GuardEndorderService, UserGuardService, GuardCurrencyService, MetaTitleGuard]
  },


  { path: 'successOrder/:orderId', component: SuccessOrderComponent, canActivate: [GuardSuccessOrderService] },


  // 404
  { path: '404/:error', component: ErrorUrlComponent },
  { path: '404', component: ErrorUrlComponent },

  //Disabled order
  { path: 'disabledorder', component: DisabledOrderComponent },
  { path: 'disabledorder/:point_of_sale', component: DisabledOrderComponent },

  // Auth
  { path: 'auth/:redirectPage/:smsKey', component: AuthComponent, canActivate: [Authguard] },

  { path: 'auth/:redirectPage', component: AuthComponent, canActivate: [Authguard] },

  //Redirect Firebase
  { path: 'redirectFb', component: RedirectFbComponent, canActivate: [AuthGuardRedirectFb] },

  // Backoffice Client
  {
    path: 'home',
    component: MainComponent,
    canActivate: [AuthGuardMainService],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'account', component: AccountComponent },
      { path: 'addresses', component: AddressesComponent },
      { path: 'cards', component: CardsComponent },
      { path: 'notes', component: NotesComponent },
      { path: 'notes/:merchantId', component: NotesComponent },
      { path: 'orders', component: OrdersComponent },
      { path: 'recharge/:merchantId', component: RechargeComponent },
      { path: 'recharge/:merchantId/:nepting/:payment', component: RechargeComponent },
      { path: 'refills/:merchantId', component: RefillsComponent },
      { path: 'merchantOptions/:merchantId', component: MerchantOptionsComponent },
      { path: 'fidelity/:merchantId', component: FidelityComponent },
      { path: 'cashlessOptions/:merchantId', component: CashlessOptionsComponent },
      { path: 'clientLogs', component: ClientAccountLogsComponent },
      { path: 'bookings', component: ReservationComponent },
      { path: 'bp/:merchantId', component: MerchantComponent },
      { path: 'credits', component: CreditsComponent },
      { path: 'credits/:merchantId', component: CreditsComponent },
      { path: 'credits/:nepting/:payment', component: CreditsComponent },
      { path: 'credits/:merchantId/:nepting/:payment', component: CreditsComponent }
    ]
  },

  //Terms
  // { path: 'merchantTerms/:userKey/:posId', component: MerchantTermsComponent },
  { path: 'merchantTerms/:merchantName/:webshopId', component: FulleMerchantTermsComponent },

  // Invoice recharge
  { path: 'invoiceRecharge', component: InvoiceRechargeComponent },
  { path: 'invoiceRecharge/:userKey/:rechargeId', component: InvoiceRechargeComponent },

  // Redirection a la thai en dur
  { path: 'pointofsale/ee630214f255eb3add9b4c6f24ee35eaba99ecf3', redirectTo: "p/a-la-thai-%21/NDQyMzVfNjJmNQ" },

  // Redirect 404
  { path: '**', redirectTo: "/404/invalid" },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking'
    }),

    Angulartics2Module.forRoot({
      pageTracking: {
        excludedRoutes: ["/:userId", "/:userId/:posId", "/:userId/:posId", "/order", "/auth"],
        clearQueryParams: true,
        clearHash: true,
      }
    }),

  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule {

  // constructor(private router: Router){}

}
